export const fr = 'fr';
export const frLocale = 'fr-FR';

export const en = 'en';
export const enLocale = 'en-EN';
